import { useEffect, useState } from "react";
import { createPulloutPersonnelList } from "../services/AllServices";
import { showMessage } from "../utils/helpers";
import { useNavigate } from "react-router-dom";

const usePulloutLetterNamesViewController = () => {

    const [selectedFile, setSelectedFile] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [loading, setLoading] = useState(false);
    const [fileName, setFileName] = useState("");

    const navigate = useNavigate();

    const uploadFile = async () => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("authorised_personnel_csv", selectedFile);
            let responseData = await createPulloutPersonnelList(formData);
            if (responseData) {
                showMessage("success", "Authorized Personnel have been added successfully");
                setSaveStatus(true);
                navigate("/home");
            } else {
                showMessage("error", responseData?.detail || "Something went wrong");
            }
        } catch (error) {
            showMessage("error", error?.response?.data?.message || "Something went wrong");
        }
        setSelectedFile(null);
        setFileName("");
        setLoading(false);
    };

    const messages = [
        "* Please ensure that the file format is correct.",
        "* The file must contain only the names of the authorized personnel.",
    ];

    useEffect(() => {
        if (selectedFile) {
            setSaveStatus(false);
        } else {
            setSaveStatus(true);
        }
    }, [selectedFile]);
    const goBack = () => {
        navigate('/home')
    };


    return {
        goBack,
        setSelectedFile,
        saveStatus,
        uploadFile,
        selectedFile,
        fileName,
        setFileName,
        messages,
        loading
    };
};

export default usePulloutLetterNamesViewController;